<div class="accent-footer"></div>
<div class="company-logo"></div>
<app-main-menu></app-main-menu>
